import React from 'react'
import PropType from 'prop-types'
import './Container.scss'

const Container = props => {
  return (
    <div className={`Container${props.paddedBottom ? ' padded-bottom' : ''}`}>
      {props.children}
    </div>
  )
}

Container.propTypes = {
  children: PropType.any,
  className: PropType.string,
  paddedBottom: PropType.bool,
}

export default Container
